export default __webpack_public_path__ + "static/media/Snd2.291ef0ad.mp3";